export const assertSlotNonNull = (el, componentName, slotName) => {
    assertNonNull(el, `${componentName} component requires a slot named "${slotName}" in order to work properly`);
};
export const assertNonNull = (el, message) => {
    if (!el) {
        throw new Error(`Chameleon error: ${message}`);
    }
};
